'use client';

import React from 'react';
import GetAccessOptions from './GetAccessOptions';

type SignUpPanelProps = {
	/** Back arrow: steps back to the menu. */
	onClose: () => void;
	/** A parent/provider choice: the whole menu closes, as the pathname may not change. */
	onNavigate: () => void;
	backIcon?: string;
};

// The mobile menu's sign-up panel; it slides in like the search and login panels.
export default function SignUpPanel({ onClose, onNavigate, backIcon }: SignUpPanelProps) {
	return (
		<div className="nav-form signup-form">
			<div className="header mobile-only">
				<button type="button" className="back-button" onClick={onClose}>
					{/* eslint-disable-next-line @next/next/no-img-element */}
					<img
						src={backIcon ?? '/images/icons/dark-icons/Left-Direction.svg'}
						className="icon-normal"
						width={24}
						height={24}
						alt=""
					/>
				</button>
			</div>
			<div className="nav-form-container">
				<h1 className="mobile-only title">Sign up</h1>
				<GetAccessOptions onSelect={onNavigate} />
			</div>
		</div>
	);
}
